import Vue from "vue";
import App from "./App.vue";
import { store } from "./store";
import { createRouter } from "./router";
import VueGtag from "vue-gtag";
import vSelect from "vue-select";
import { BootstrapVue, IconsPlugin, ToastPlugin } from "bootstrap-vue";
import browserDetect from "vue-browser-detect-plugin";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faPlusCircle,
  faMinusCircle,
  faFileDownload,
  faPlay,
  faFileExport,
} from "@fortawesome/free-solid-svg-icons";
library.add(faMinusCircle, faPlusCircle, faFileDownload, faPlay, faFileExport);

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);

// Styles
import 'bootstrap-icons/font/bootstrap-icons.css'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-date-pick/dist/vueDatePick.css";
import "vue-select/dist/vue-select.css";
import "@/assets/css/main.css";
import "@/assets/css/datepick.css";
import globalConfig from "@/mixins/globalConfig";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ToastPlugin);
Vue.use(vSelect);
Vue.use(browserDetect);

export const bus = new Vue();

Vue.config.productionTip = false;

// Initialize the app after loading runtime config
const initializeApp = async () => {
  try {
    const runtimeConfig = await fetch("/config/runtime.json").then((res) => {
      if (!res.ok) throw new Error("Failed to fetch runtime.json");
      return res.json();
    });

    // Commit runtime config to Vuex
    store.commit("setConfig", runtimeConfig);

    // Use runtime config for Google Analytics
    Vue.use(VueGtag, {
      config: { id: runtimeConfig.GoogleTagId },
    });

    // Use global config
    Vue.mixin(globalConfig);

    store.dispatch("determineVideoInHomeSubdomain");

    // Create the router dynamically after loading config
    const router = createRouter();

    // Initialize Vue app
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  } catch (error) {
    console.error("Failed to initialize app:", error);
  }
};

initializeApp();
